var _circle, _circle2, _circle3, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 48,
    fill: "#F7F7F8",
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 36,
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 24,
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 64,
    height: 72,
    rx: 4,
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30,
    width: 72,
    height: 72,
    rx: 4,
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 80,
    height: 72,
    rx: 6,
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.808 82C48.318 82 48.0731 82 47.8859 81.9014C47.7213 81.8147 47.5874 81.6764 47.5035 81.5062C47.4082 81.3128 47.4082 81.0596 47.4082 80.5531V78.0566C47.4082 77.8064 47.4082 77.6813 47.4385 77.5654C47.4653 77.4627 47.5095 77.3658 47.5689 77.279C47.636 77.181 47.7292 77.1012 47.9158 76.9417L55.9535 70.0694C56.5202 69.5838 57.0049 69.1291 57.4075 68.7052C57.8176 68.2736 58.1308 67.8304 58.347 67.3757C58.5707 66.921 58.6826 66.4162 58.6826 65.8613C58.6826 65.2524 58.5558 64.7322 58.3023 64.3006C58.0562 63.869 57.7132 63.5376 57.2733 63.3064C56.8334 63.0674 56.3263 62.948 55.7521 62.948C55.178 62.948 54.6709 63.0674 54.231 63.3064C53.7985 63.5453 53.463 63.896 53.2243 64.3584C53.1796 64.4451 53.1391 64.5353 53.1027 64.629C52.844 65.2962 52.7147 65.6298 52.6085 65.7504C52.4842 65.8917 52.44 65.9225 52.2669 65.9893C52.1191 66.0462 51.9016 66.0462 51.4666 66.0462H48.3606C47.8778 66.0462 47.6364 66.0462 47.4358 65.9288C47.275 65.8347 47.1173 65.6459 47.0507 65.4678C46.9677 65.2455 46.9982 65.0317 47.0593 64.6041C47.2116 63.5384 47.5404 62.5856 48.0457 61.7457C48.769 60.5434 49.7906 59.6185 51.1104 58.9711C52.4302 58.3237 53.9775 58 55.7521 58C57.5865 58 59.1747 58.3044 60.5169 58.9133C61.8666 59.5145 62.9068 60.3622 63.6375 61.4566C64.3757 62.5511 64.7448 63.8343 64.7448 65.3064C64.7448 66.2158 64.5621 67.1214 64.1968 68.0231C63.8314 68.9171 63.1752 69.9075 62.2282 70.9942C61.2812 72.0809 59.9353 73.3757 58.1905 74.8786L56.0758 76.7C56.055 76.7179 56.0429 76.7445 56.0429 76.7726C56.0429 76.8248 56.0839 76.8671 56.1344 76.8671H63.591C64.081 76.8671 64.326 76.8671 64.5132 76.9656C64.6778 77.0523 64.8116 77.1907 64.8955 77.3608C64.9909 77.5543 64.9909 77.8075 64.9909 78.3139V80.5531C64.9909 81.0596 64.9909 81.3128 64.8955 81.5062C64.8116 81.6764 64.6778 81.8147 64.5132 81.9014C64.326 82 64.081 82 63.591 82H48.808Z",
    fill: "#B9BAC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6001 58.3237C78.0901 58.3237 78.3351 58.3237 78.5223 58.4223C78.6869 58.509 78.8208 58.6473 78.9046 58.8175C79 59.0109 79 59.2641 79 59.7706V80.5531C79 81.0596 79 81.3128 78.9046 81.5062C78.8208 81.6764 78.6869 81.8147 78.5223 81.9014C78.3351 82 78.0901 82 77.6001 82H74.181C73.691 82 73.446 82 73.2589 81.9014C73.0943 81.8147 72.9604 81.6764 72.8765 81.5062C72.7812 81.3128 72.7812 81.0596 72.7812 80.5531V64.3515C72.7812 64.2914 72.7341 64.2428 72.676 64.2428C72.657 64.2428 72.6383 64.2481 72.622 64.2582L69.7546 66.0311C69.0611 66.46 68.7143 66.6744 68.429 66.6466C68.1803 66.6224 67.9534 66.4895 67.8056 66.2812C67.6361 66.0425 67.6361 65.6248 67.6361 64.7895V62.6959C67.6361 62.3998 67.6361 62.2518 67.6769 62.1186C67.7131 62.0006 67.7722 61.8916 67.8507 61.7983C67.9394 61.6928 68.0616 61.6156 68.306 61.4613L72.9372 58.536C73.0623 58.457 73.1248 58.4175 73.1917 58.3896C73.2511 58.3647 73.313 58.3468 73.3762 58.3359C73.4473 58.3237 73.5206 58.3237 73.6672 58.3237H77.6001Z",
    fill: "#B9BAC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34H76",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42L104 42",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 18,
    width: 6,
    height: 16,
    rx: 3,
    fill: "#D9D9DE",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 18,
    width: 6,
    height: 16,
    rx: 3,
    fill: "#D9D9DE",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e6242337c185119d85a7a86f22da1e55.svg";
export { ForwardRef as ReactComponent };